/**
 * 会议认证场次
 * @Author wuTao
 */
import React from 'react';
import {connect} from 'dva';
import {component_tool, framework_tool} from '@/tool'
import {modelUtils} from "@/utils";
import moment from "moment";

let {WizTable, WizSpin} = component_tool

const formatterTime = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
}
let {
  WizContainer,
} = framework_tool;


class AuthLiveTimes extends WizContainer {
  componentName = 'AuthLiveTimes';

  constructor(props) {
    super(props);
    this.state = {
      value: []
    };
  }

  _componentDidMount() {
    const {record} = this.props;
    if (record.id) {
      this.doAction({
        path: "interactLive/getInteractLiveTimes",
        payload: {
          key: "getInteractLiveTimes_" + record.id,
          apiParams: {
            id: record.id
          }
        }
      });
    }
  }

  propsAndStateOnChange = {
    remoteAuthLiveTimes: this._getDataOver.bind(this)
  };

  _getDataOver(nextProps, nextState) {
    if (nextProps.remoteAuthLiveTimes.code === 1) {
      let value = nextProps.remoteAuthLiveTimes.data;
      nextState.value = value;
    }
    return true
  }


  _render() {
    let {type, record, interactLiveLoading} = this.props;
    let columns = [
      {
        title: '场次名称',
        dataIndex: 'name',
        key: 'name',
        width: 50,
        render: (text, record, index) => (
          <a style={{color: '#1890ff'}}>场次{index + 1}</a>
        ),
      },
      {
        title: '开始时间',
        dataIndex: 'startTime',
        key: 'startTime',
        width: 100,
        render: (text, record) => (
          <>{formatterTime(record.startTime)}</>
        ),
      }
    ]
    return (
      <WizSpin tip={''} spinning={interactLiveLoading}>
        <WizTable pagination={false} columns={columns} dataSource={this.state.value}/>
      </WizSpin>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  let {record} = ownProps
  const {interactLive} = state;
  const remoteAuthLiveTimes = modelUtils.getModelEntity(interactLive, "getInteractLiveTimes_" + ownProps.record.id);
  const load = modelUtils.getLoadingState(state, ['interactLive']);
  return {
    remoteAuthLiveTimes,
    ...load
  }
};
const options = {withRef: true};
export default connect(mapStateToProps, null, null, options)(AuthLiveTimes);
